import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import client from "./client";
import type { PaginatedResponse, SourceTenant } from "./types";

export function useSourceTenants(params?: Record<string, string>) {
  return useQuery<PaginatedResponse<SourceTenant>>({
    queryKey: ["source-tenants", params],
    queryFn: async () => {
      const { data } = await client.get("/integrations/source-tenants/", { params });
      return data;
    },
  });
}

export function useTenantSourceTenants(tenantId: string | undefined) {
  return useQuery<PaginatedResponse<SourceTenant>>({
    queryKey: ["source-tenants", "tenant", tenantId],
    queryFn: async () => {
      const { data } = await client.get(`/tenants/${tenantId}/source-tenants/`);
      return data;
    },
    enabled: !!tenantId,
  });
}

export function useUpdateSourceTenantMapping() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, tenants }: { id: string; tenants: string[] }) => {
      const { data } = await client.patch(`/integrations/source-tenants/${id}/`, {
        tenants,
      });
      return data;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["source-tenants"] });
      qc.invalidateQueries({ queryKey: ["devices"] });
    },
  });
}
